import React from 'react';

const ONE_BUTTON_LAYOUT = 1;

const { Provider, Consumer } = React.createContext({
  showStickyBar() {},
  hideStickyBar() {},
  init() {},
  isActive: false,
  initialized: false,
});

class StickyBarProvider extends React.Component {
  state = {
    isActive: false,
    initialized: false,
    buttonLayout: false,
  };

  init = () => {
    this.setState({ initialized: true });
  };

  showStickyBar = () => {
    if (!this.state.isActive) {
      this.setState({ isActive: true });
    }
  };

  hideStickyBar = () => {
    if (this.state.isActive) {
      this.setState({ isActive: false });
    }
  };

  activateOneButtonLayout = () => {
    this.setState({ buttonLayout: ONE_BUTTON_LAYOUT });
  };

  isOneButtonLayout = () => {
    return this.state.buttonLayout === ONE_BUTTON_LAYOUT;
  };

  render() {
    const { isActive, initialized } = this.state;
    return (
      <Provider
        value={{
          isActive,
          initialized,
          init: this.init,
          showStickyBar: this.showStickyBar,
          hideStickyBar: this.hideStickyBar,
          activateOneButtonLayout: this.activateOneButtonLayout,
          isOneButtonLayout: this.isOneButtonLayout,
        }}
      >
        {this.props.children}
      </Provider>
    );
  }
}

export { StickyBarProvider, Consumer as StickyBarConsumer };
